import ModelPrototype, { Method } from "@models/ModelPrototype";

export default class Days extends ModelPrototype {
  public async get(): Promise<any> {
    try {
      return this.withUrl(`networking/days`).setMethod(Method.GET).request();
    } catch (Exception) {
      throw Exception;
    }
  }
}
